<div
  class="doughnut-chart"
  [class.empty]="!dataset()?.data?.length"
>
  @if (dataset()?.data?.length) {
    <highcharts-chart
      class="highcharts-light"
      [options]="chartOptions()"
    />
  } @else {
    No data available
  }
</div>
